import PageWrapper from "../../shared/wizard/PageWrapper";
import UploadFile from "../../upload-file/UploadFile";
import FileIcon from "../../upload-file/file-icon/FileIcon";
import Styles from "../AnonForms.module.css";

function Documents({ handleDocuments, documents, config }) {
  return (
    <PageWrapper legendInfo="Documents: ">
      <div className={Styles.labelInputContainer}>
        <UploadFile
          getFiles={(files) => handleDocuments(files, "add")}
          size={(documents.size / config.totalFileSizeLimitDivisor).toFixed(2)}
        />

        <div className="documentContainer">
          {documents.files &&
            documents.files.map((document, index) => {
              return (
                <FileIcon
                  key={index}
                  file={document}
                  removeFile={(file) => handleDocuments(file, "remove")}
                />
              );
            })}
        </div>
      </div>
    </PageWrapper>
  );
}

export default Documents;
